import { render, staticRenderFns } from "./UserInterests.vue?vue&type=template&id=5b39840e&"
import script from "./UserInterests.vue?vue&type=script&lang=js&"
export * from "./UserInterests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports